import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { GdpProjectService } from '../services/gdp-project.service';

/**
 * Un proyecto KANBAN tiene una única pantalla: /gdp/projects/:projectId con el
 * tablero embebido. Los enlaces antiguos a su tablero
 * (/gdp/projects/:pid/sprints/:sid/board — emails, notificaciones, favoritos)
 * se redirigen a esa página CONSERVANDO los query params (?task=, ?us=), que
 * la página única procesa igual que hacía el tablero. Para SCRUM la ruta de
 * tablero sigue funcionando tal cual (el guard deja pasar).
 */
export const kanbanProjectRedirectGuard: CanActivateFn = route => {
  const router = inject(Router);
  const projectService = inject(GdpProjectService);
  const projectId = Number(route.paramMap.get('projectId'));
  if (!Number.isFinite(projectId) || projectId <= 0) {
    return true;
  }
  return projectService.getProject(projectId).pipe(
    map(project => project.type === 'KANBAN'
      ? router.createUrlTree(['/gdp/projects', projectId], { queryParams: route.queryParams })
      : true),
    // Si el proyecto no se puede cargar, que decida la página de tablero
    catchError(() => of(true))
  );
};
